import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vs } from 'react-syntax-highlighter/dist/esm/styles/prism';

import './index.less';

import IbIcon from '../common/IbIcon';
import IbButton from '../common/IbButton';

const MAIN_CLASS_NAME = 'syntax-highlighter-container';
const COPY_BUTTON_CLASS_NAME = `${MAIN_CLASS_NAME}__copy-button`;

export interface ISyntaxHighlightedContentProps {
  children: string;
  language?: string;
}

const SyntaxHighlightedContent = ({ children, language }: ISyntaxHighlightedContentProps): JSX.Element => {
  const onCopyButtonClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    navigator.clipboard.writeText(children);
  };

  return (
    <div className={MAIN_CLASS_NAME}>
      <SyntaxHighlighter language={language || 'text'} style={vs}>
        {children}
      </SyntaxHighlighter>
      <IbButton
        className={COPY_BUTTON_CLASS_NAME}
        icon={<IbIcon iconName="clipboard" />}
        type="icon"
        onClick={onCopyButtonClick}
      />
    </div>
  );
};

export default SyntaxHighlightedContent;
